module.exports = __webpack_public_path__ + "static/media/typ2_icon.32b71ce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/typ2_icon.svg
// module id = 114
// module chunks = 0